<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Overview</h6>
          <h1 class="header-title">Graduates</h1>
        </div> <!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <h3>Filter</h3>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
            <label class="control-label">Program</label>
            <multiselect
              @input="handleSelectProgramCallback"
              :value="programSelected"
              :options="programOptions"
              track-by="id"
              label="name"
              :allow-empty="false"
              :searchable="false"
              :show-labels="false"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
            <label class="control-label">Placement</label>
            <multiselect
              @input="handleSelectPlacementCallback"
              :value="placementSelected"
              :options="placementOptions"
              track-by="id"
              label="number"
              :allow-empty="false"
              :searchable="false"
              :show-labels="false"
              :show-no-results="true"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
            <label class="control-label">Show</label>
            <multiselect
              v-model="taskSelected"
              label="text"
              :options="taskOptions"
              :allow-empty="false"
              :searchable="false"
              :show-labels="false"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 col-md-6 col-lg-12 col-xl-12">
          <div class="form-group">
            <label class="control-label">Graduate Name</label>
            <input v-model="filters.search" type="text" class="form-control" />
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->

      <div class="decorative-divider mt-0"></div>

      <div class="card">
        <loading-spinner v-if="fetching"/>

        <no-results v-else-if="haveNoGraduates">
          No graduates found.
        </no-results>

        <ul v-else class="list-data">
          <graduates-list-item v-for="graduate in graduates" :graduate="graduate" :key="graduate.id"/>
        </ul><!-- /.list-data -->

        <lazy-loading
          :loading="$loading"
          :reached-bottom="handleGetNextGraduatesCallback"
          ref="lazy">
          <loading-spinner slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div><!-- /.card -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { graduateComputed, graduateMethods, programComputed, programMethods } from 'vx/helpers'
import { appliesFilters } from 'mixins'
import { concat, map } from 'lodash'
import GraduatesListItem from './GraduatesListItem'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [appliesFilters],

  components: {
    GraduatesListItem,
    Multiselect
  },

  data () {
    return {
      fetching: false,
      filters: {
        search: null,
        program_id: 'all',
        placement_id: 'all',
        tasks: 'all'
      },
      programSelected: null,
      placementSelected: null,
      tasks: [
        {
          value: 'all',
          text: 'All'
        },
        {
          value: 'overdue',
          text: 'Overdue Tasks'
        }
      ]
    }
  },

  computed: {
    ...graduateComputed,
    ...programComputed,

    haveNoGraduates () {
      return this.graduates.length === 0
    },

    programOptions () {
      return concat({ id: 'all', name: 'Show All', placements: [{ id: 'all', number: 'All' }] }, this.programs)
    },

    taskOptions () {
      if (this.$userIsManager) {
        return concat(this.tasks, { value: 'open', text: 'Open Tasks' })
      }
      return this.tasks
    },

    placementOptions () {
      let options = this.programSelected ? this.programSelected.placements : []

      options = map(options, (placement) => {
        if (placement.number === 1) {
          return { id: placement.id, number: `${placement.number} - Home Agency` }
        }
        return placement
      })

      return options
    },

    taskSelected: {
      get () {
        return this.taskOptions.find(option => option.value === this.filters.tasks)
      },

      set (option) {
        this.filters.tasks = option.value
      }
    }
  },

  async created () {
    await this.getPrograms()

    this.programSelected = this.programs.find(program => program.id === parseInt(this.$route.query.program_id)) || { id: 'all', name: 'Show All', placements: [{ id: 'all', number: 'All' }] }
    this.placementSelected = this.programSelected.placements.find(placement => placement.id === parseInt(this.$route.query.placement_id)) || { id: 'all', number: 'All' }

    this.filters.placement_id = this.placementSelected.id
    this.filters.program_id = this.programSelected.id
  },

  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true

        await this.getGraduates(params)

        this.fetching = false

        this.$nextTick(() => {
          if (this.$refs.lazy) {
            this.$refs.lazy.$emit('reset')
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    ...graduateMethods,
    ...programMethods,

    async handleGetNextGraduatesCallback () {
      await this.getGraduatesForNextPage(this.queryParams)

      this.$refs.lazy.$emit('reset')
    },

    handleSelectProgramCallback (program) {
      this.programSelected = program

      this.filters.program_id = program
        ? program.id
        : null

      this.handleSelectPlacementCallback({ id: 'all', number: 'All' })
    },

    handleSelectPlacementCallback (placement) {
      this.placementSelected = placement

      this.filters.placement_id = placement
        ? placement.id
        : null
    }
  }
}
</script>
